/* eslint-disable max-len */
import React, { useEffect } from 'react'
import TableRow from './tableRow'
import TableShimmer from './tableShimmer';
import NoSearchScreen from '../../CommonComponent/ListingScreens/NoSearchScreen';
import EmptyScreen from '../../CommonComponent/ListingScreens/EmptyScreen';
import TableHeader from '../../CommonComponent/ListingScreens/TableHeader';

export default function TableBody(props) {

    const { bidders , handleSort, isFilterApplied, searchParams, loading, currentSortColumn} =props;

    const bidderColumns = [
        { label: "Name", sortKey: "name", testId: "bidder_name", id: "bidder_name", minWidth: "200px" },
        { label: "Email", sortKey: "email_address", testId: "bidder_email", id: "email_address", minWidth: "300px" },
        { label: "Date Registered", sortKey: "created_at", testId: "date_registered", minWidth: "180px" },
        { label: "Marketing", id: "marketing", minWidth: "120px", center: true },
        { label: "", minWidth: "120px" }
    ];

    return (
        <div className='pb-[200px] pt-2 overflow-auto customScrollbar'>
            <div className="z-10 w-fit border rounded-lg border-[#DEDEDE] xl:w-full" style={{transform: "rotateX(180deg)"}}>
                <table className="w-full overflow-auto table-auto " 
                    style={{transform: "rotateX(-180deg)", borderRadius:9}}>
                    <TableHeader columns={bidderColumns} handleSort={handleSort} currentSortColumn={currentSortColumn} />
                    {/* <!-- empty auction list --> */}
                    {(bidders?.length===0 && isFilterApplied!==true && searchParams.get('keyword')=== null && !loading) &&
                    <tbody>
                        <EmptyScreen message="Currently no bidders" cols={7}/>
                    </tbody>
                    }
                    {/* <!-- empty search  --> */}
                    {(searchParams.get('keyword')!== null && bidders.length===0 && isFilterApplied===false && !loading) && 
                        <NoSearchScreen cols={7} searchValue={decodeURIComponent(searchParams.get('keyword'))} />}
                    {(searchParams.get('keyword')!== null && isFilterApplied===true && bidders.length===0) && 
                        <EmptyScreen message="No results found" cols={7}/>}
                    {/* <!-- empty filter --> */}
                    {(isFilterApplied===true && bidders.length===0 && searchParams.get('keyword')=== null ) && 
                        <EmptyScreen message="No results for applied filter" cols={7}/>}
                    {loading && <TableShimmer/>}
                    {!loading && <tbody className="mt-5">
                        <TableRow bidders={bidders}/>
                    </tbody>}
                </table>
            </div>
        </div>
    )
}
